import { useCallback, useEffect, useState } from 'react';
import { CommentList } from './CommentList';

/**
 * 선택적으로 열어 볼 수 있는 댓글
 * 기본적으로 댓글의 수만 보여줌
 */
export const CommentListCollapse = ({ type, root, readOnly = false, useCollapse = true }) => {
    const [showComment, setToggle] = useState(false);

    // 펼쳐보기면 기본적으로 펼치고 목록을 가져온다.
    useEffect(() => {
        if (useCollapse) return;
        setToggle(true);
    }, [root.id, type, useCollapse]);


    // 펼치기 가능하면 댓글을 가져오기
    const openComment = useCallback(() => {
        if (!useCollapse) return;
        setToggle(!showComment);
    }, [showComment, useCollapse]);

    return (
        <div className={`reply_area ${showComment ? 'toggle' : ''} `}>
            <button type="button" className="reply_btn" onClick={openComment}><span>댓글 ({root.commentCount})</span></button>
            {showComment && <CommentList type={type} root={root} readOnly={readOnly} /> }
        </div>
    );
};